import { AuthStatus } from "@aws-amplify/ui";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { useEffect, useState } from "react";

interface AuthStateChangeDetectorProps {
  whenAuthStateMatches?: AuthStatus;
  action: () => void;
}

const AuthStateChangeDetector = ({
  whenAuthStateMatches,
  action,
}: AuthStateChangeDetectorProps) => {
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);
  const [prevAuthStatus, setPrevAuthStatus] = useState<
    AuthStatus | undefined
  >();

  useEffect(() => {
    if (authStatus === "configuring") return;
    if (!prevAuthStatus) return setPrevAuthStatus(authStatus);

    if (prevAuthStatus !== authStatus) {
      setPrevAuthStatus(authStatus);
      if (!whenAuthStateMatches || authStatus === whenAuthStateMatches) {
        action();
      }
    }
  }, [action, authStatus, prevAuthStatus, whenAuthStateMatches]);

  return <></>;
};

export default AuthStateChangeDetector;
